import type { VisualPromptDefinition } from '@/types/visualPrompts/visualPrompt.types';

const CUSTOM_PROMPTS_KEY = 'litium-visual-prompt-custom-definitions';

export const getCustomVisualPrompts = (): VisualPromptDefinition[] => {
  try {
    const raw = localStorage.getItem(CUSTOM_PROMPTS_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as VisualPromptDefinition[];
    return Array.isArray(parsed) ? parsed.filter((p) => p?.id && p?.title) : [];
  } catch {
    return [];
  }
};

export const saveCustomVisualPrompt = (
  definition: VisualPromptDefinition,
): void => {
  const existing = getCustomVisualPrompts();
  const next = [
    { ...definition, isCustom: true as const },
    ...existing.filter((p) => p.id !== definition.id),
  ];
  localStorage.setItem(CUSTOM_PROMPTS_KEY, JSON.stringify(next));
};

export const deleteCustomVisualPrompt = (promptId: string): void => {
  const next = getCustomVisualPrompts().filter((p) => p.id !== promptId);
  localStorage.setItem(CUSTOM_PROMPTS_KEY, JSON.stringify(next));
};
